// extracted by mini-css-extract-plugin
module.exports = {"Burger":"byP-Vcacm4fC_qCtKVE-P"};